module.exports = __webpack_public_path__ + "4617d784544b26aa93ef52067584cb37.png";